import { ActionButton } from '../types';

const getManuelNodesSceneActions = (): ActionButton[] => [];

export default getManuelNodesSceneActions;
